import { z } from 'zod';
import {
  dateRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { voucherStatuses } from 'store/vouchers';

export const adminShopVouchersFiltersSchema = z
  .object({
    search: z.string().catch(''),
    status: z.array(z.enum(voucherStatuses)).catch([]),
    prices: z.array(z.string()).catch([]),
    createdAt: dateRangeSchema,
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
